import { action } from 'satcheljs';
import { CLPLabel } from 'owa-mail-clp-store/lib/store/store';
import ComposeViewState from '../store/schema/ComposeViewState';

export default action(
    'setSelectedCLPLabel',
    (labelToSet: CLPLabel, viewState: ComposeViewState) => ({ labelToSet, viewState })
);
